export const types = {
  CHANGE_DATE_PICKER: "CHANGE_DATE_PICKER",
  CHANGE_END_DATE_PICKER: "CHANGE_END_DATE_PICKER",
  CHANGE_DATE_TO_ALL_TIME: "CHANGE_DATE_TO_ALL_TIME",
};
